import React, { cloneElement } from 'react';
import PropTypes from 'prop-types';

import Col from 'antd/lib/col';
import InputNumber from 'antd/lib/input-number';
import Form from 'antd/lib/form';
import Input from 'antd/lib/input';
import Select from 'antd/lib/select';
import DatePicker from 'antd/lib/date-picker';
import Tooltip from 'antd/lib/tooltip';
import Checkbox from 'antd/lib/checkbox';
import * as Icons from '@ant-design/icons';

/**
 * Custom Input
 * Antd Input excentsion
 * */
const InputWrapper = ({
  name,
  placeholder,
  form,
  label,
  required,
  initialValue,
  message,
  validator,
  formatter,
  parser,
  min,
  max,
  style,
  type,
  subtype,
  format,
  span,
  options,
  showSearch,
  tooltip,
  optionAttribute,
  extra,
  onChange,
  offset,
  children,
  disabled,
  valuePropName,
  onBlur,
}) => {
  let itemsRules = {};
  itemsRules.required = required;
  if (message) {
    itemsRules.message = message;
  }
  if (validator) {
    itemsRules.validator = validator;
  }

  const rules = [itemsRules];

  let propsPop = {};
  if (placeholder) {
    propsPop.placeholder = placeholder;
  }
  if (formatter) {
    propsPop.formatter = formatter;
  }
  if (min) {
    propsPop.min = min;
  }
  if (max) {
    propsPop.max = max;
  }
  if (parser) {
    propsPop.parser = parser;
  }
  if (showSearch) {
    propsPop.showSearch = showSearch;
  }
  if (disabled) {
    propsPop.disabled = disabled;
  }
  if (onBlur) {
    propsPop.onBlur = onBlur;
  }
  let render;
  switch (type) {
    case 'number':
      render = <InputNumber {...propsPop} style={style} />;
      break;
    case 'date':
      switch (subtype) {
        case 'month':
          render = (
            <DatePicker.MonthPicker
              {...propsPop}
              format={format}
              style={style}
            />
          );
          break;
        default:
          render = <DatePicker {...propsPop} format={format} style={style} />;
          break;
      }

      break;
    case 'area':
      render = <Input.TextArea {...propsPop} style={style} />;
      break;
    case 'checkbox':
      render = <Checkbox {...propsPop} style={style} />;
      break;
    case 'select':
      render = (
        <Select {...propsPop} style={style}>
          {options.map(opcion => (
            <Select.Option
              key={optionAttribute ? opcion.id : opcion}
              value={optionAttribute ? opcion.id : opcion}
            >
              {optionAttribute ? opcion[optionAttribute] : opcion}
            </Select.Option>
          ))}
        </Select>
      );
      break;
    case 'input':
      render = (
        <Input
          onChange={val => {
            if (onChange) onChange(val.target.value);
          }}
          {...propsPop}
          style={style}
        />
      );
      break;
    case 'custom':
      render = cloneElement(children, {
        ...propsPop,
      });
      break;
  }
  if (tooltip) {
    label = (
      <span>
        {label + ' '}
        <Tooltip title={tooltip}>
          <Icons.QuestionCircleOutlined />
        </Tooltip>
      </span>
    );
  }
  // console.log({ name, initialValue });
  return (
    <Col offset={offset} span={span}>
      <Form.Item label={label} extra={extra}>
        {form.getFieldDecorator(name, {
          valuePropName,
          initialValue: initialValue,
          rules,
        })(render)}
      </Form.Item>
    </Col>
  );
};

InputWrapper.propTypes = {
  placeholder: PropTypes.string,
  tooltip: PropTypes.string,
  span: PropTypes.number,
  type: PropTypes.string,
  name: PropTypes.string,
  form: PropTypes.object,
  label: PropTypes.string,
  required: PropTypes.bool,
  validator: PropTypes.func,
  //initialValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  message: PropTypes.string,
  valuePropName: PropTypes.string,
  formatter: PropTypes.func,
  parser: PropTypes.func,
  min: PropTypes.number,
  max: PropTypes.number,
  style: PropTypes.object,

  //DatePicker
  format: PropTypes.string,

  //Select
  options: PropTypes.array,
  showSearch: PropTypes.bool,
};

InputWrapper.defaultProps = {
  name: 'TEST',
  valuePropName: 'value',
  label: 'Change Properties',
  format: 'DD/MM/YYYY',
  span: 8,
  options: [],
};

export default InputWrapper;
